export default {
  LOCALE: 'locale',
  SAVED_PATH: 'savedPath',
};
